// app/core/course.model.ts
import { Injectable } from '@angular/core';
import { internalProduct } from 'src/app/models/marketplace/internalProducts';

@Injectable({
    providedIn: 'root',
})
export class internalProductAdapter {
    mapInternalProducts(data: any): Array<internalProduct> {
        return data?.marketplace?.internalProducts?.items;
    }
}
